let c;
const C = function() {
  let e;
  const t = [];
  for (let s = 0; s < 256; s++) {
    e = s;
    for (let o = 0; o < 8; o++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[s] = e;
  }
  return t;
}, R = function(e) {
  c = c || C();
  let t = -1;
  for (let s = 0; s < e.length; s++)
    t = t >>> 8 ^ c[(t ^ e.charCodeAt(s)) & 255];
  return `${(t ^ -1) >>> 0}`;
};
var m = function() {
  var e = this, t = e.$createElement, s = e._self._c || t;
  return e.searchResponse ? s(e.productListComponent, e._b({
    tag: "component",
    attrs: {
      "search-request-id": e.searchRequestId,
      "search-response": e.searchResponse
    }
  }, "component", e.$attrs, !1)) : e._e();
}, y = [];
function v(e, t, s, o, i, h, u, _) {
  var r = typeof e == "function" ? e.options : e;
  t && (r.render = t, r.staticRenderFns = s, r._compiled = !0), o && (r.functional = !0), h && (r._scopeId = "data-v-" + h);
  var a;
  if (u ? (a = function(n) {
    n = n || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !n && typeof __VUE_SSR_CONTEXT__ < "u" && (n = __VUE_SSR_CONTEXT__), i && i.call(this, n), n && n._registeredComponents && n._registeredComponents.add(u);
  }, r._ssrRegister = a) : i && (a = _ ? function() {
    i.call(
      this,
      (r.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), a)
    if (r.functional) {
      r._injectStyles = a;
      var p = r.render;
      r.render = function(g, d) {
        return a.call(d), p(g, d);
      };
    } else {
      var l = r.beforeCreate;
      r.beforeCreate = l ? [].concat(l, a) : [a];
    }
  return {
    exports: e,
    options: r
  };
}
const q = {
  name: "CentraSearchController",
  props: {
    productListComponent: {
      type: String,
      default: "ProductList"
    },
    searchQuery: {
      type: Object,
      default: () => {
      }
    },
    centraCategoryId: {
      type: String,
      default: void 0
    },
    pageSize: {
      type: String,
      default: "20"
    },
    startingPage: {
      type: String,
      default: "1"
    }
  },
  watch: {
    centraCategoryId() {
      this.search();
    },
    searchQuery() {
      this.search();
    }
  },
  computed: {
    initialQuery() {
      var t;
      const e = {
        ...this.searchQuery,
        limit: this.pageSize,
        __page: (t = this.$route.query.page) != null ? t : this.startingPage
      };
      return this.centraCategoryId && (e.categories = [this.centraCategoryId]), e;
    },
    searchRequestId() {
      return R(JSON.stringify(this.initialQuery));
    },
    searchResponse() {
      return this.$store.state["centra-search"].searchResponses[this.searchRequestId];
    }
  },
  serverPrefetch() {
    return this.search();
  },
  mounted() {
    this.searchResponse || this.search();
  },
  methods: {
    search() {
      if (this.searchResponse)
        return;
      const e = { ...this.initialQuery };
      return this.$emit("centra-search-loading-start", {
        searchRequestId: this.searchRequestId
      }), this.$store.dispatch("centra-search/search", {
        searchRequestId: this.searchRequestId,
        query: e
      }).then(
        () => this.$emit("centra-search-loading-success", {
          searchRequestId: this.searchRequestId
        })
      ).catch(
        () => this.$emit("centra-search-loading-failed", {
          searchRequestId: this.searchRequestId
        })
      ).finally(
        () => this.$emit("centra-search-loading-complete", {
          searchRequestId: this.searchRequestId
        })
      );
    }
  }
}, f = {};
var I = /* @__PURE__ */ v(
  q,
  m,
  y,
  !1,
  $,
  null,
  null,
  null
);
function $(e) {
  for (let t in f)
    this[t] = f[t];
}
const S = /* @__PURE__ */ function() {
  return I.exports;
}(), b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S
}, Symbol.toStringTag, { value: "Module" }));
export {
  b as CentraSearchController
};
//# sourceMappingURL=nuxt-centra-search.js.map
